import React, { useRef, useState } from "react";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { postCourseItemAddToCartData, postCourseItemLikeData, postCourseItemRegisterData } from "../services/courseService";
import { SuccessTemplate } from "./common/ToastMessage/Template";

export const CourseDetailOverview = ({ courseItemData }) => {
  const copiedToast = useRef(null);

  const [like, setLike] = useState(false);

  const handleLikeClick = async () => {
    await postCourseItemLikeData(courseItemData);
    setLike((prevLike) => !prevLike);
  };

  const handleAddToCart = async () => {
    await postCourseItemAddToCartData(courseItemData.publicId);
  };

  const handleRegister = async () => {
    await postCourseItemRegisterData(courseItemData);
  };

  const showCopiedToast = () => {
    copiedToast.current.show({ 
      severity: "success", 
      summary: "Copied", 
      detail: courseItemData?.title,
      life: 3000, 
      content: (props) => SuccessTemplate(props)
    });
  };

  return (
    <div className="course-detail-overview">
      <Toast ref={copiedToast} position="bottom-right" className="keduall-toast"/>
      <div className="px-3">
        <div className="flex justify-content-between">
          <div className="flex gap-05 align-items-center">
            <h4 className="default-text font-size-24 font-weight-400 line-height-32 m-0">{courseItemData?.price?.discountPrice}</h4>
            <p className="font-size-16 font-weight-400 line-height-24 m-0 select-none line-through gray-color">{courseItemData?.price?.originalPrice}</p>
          </div>
          <div className="bg-alice-blue p-2">
            <p className="font-weight-500 font-size-14 line-height-20 primary-color m-0">{courseItemData?.price?.discountLabel}</p>
          </div>
        </div>
        <div className="flex justify-content-center align-items-center mt-2 mb-4">
          <i className="pi pi-clock mr-2 font-size-15 red-color"></i>
          <span className="font-size-14 font-weight-500 line-height-20 red-color">{courseItemData?.price?.discountText}</span>
        </div>
      </div>
      <Divider className="gray-border" />
      <div className="px-3 mt-4 mb-4">
        <div className="flex justify-content-between align-items-center height-22 mb-3">
          <div className="flex">
            <i className="pi pi-clock mr-2 font-size-18 gray-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 default-text">Thời lượng khóa học</span>
          </div>
          <p className="font-size-14 font-weight-400 line-height-20 gray-color">{courseItemData?.courseDuration}</p>
        </div>
        <div className="flex justify-content-between align-items-center height-22 mb-3">
          <div className="flex">
            <i className="pi pi-chart-bar mr-2 font-size-18 gray-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 default-text">Cấp độ khóa học</span>
          </div>
          <p className="font-size-14 font-weight-400 line-height-20 gray-color">{courseItemData?.courseLevel}</p>
        </div>
        <div className="flex justify-content-between align-items-center height-22 mb-3">
          <div className="flex">
            <i className="pi pi-users mr-2 font-size-18 gray-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 default-text">Học sinh đã ghi danh</span>
          </div>
          <p className="font-size-14 font-weight-400 line-height-20 gray-color">{courseItemData?.enrolledQuantity}</p>
        </div>
        <div className="flex justify-content-between align-items-center height-22 mb-3">
          <div className="flex">
            <i className="pi pi-book mr-2 font-size-18 gray-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 default-text">Ngôn ngữ</span>
          </div>
          <p className="font-size-14 font-weight-400 line-height-20 gray-color">{courseItemData?.language}</p>
        </div>
        <div className="flex justify-content-between align-items-center height-22 mb-3">
          <div className="flex">
            <i className="pi pi-globe mr-2 font-size-18 gray-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 default-text">Ngôn ngữ phụ đề</span>
          </div>
          <p className="font-size-14 font-weight-400 line-height-20 gray-color">{courseItemData?.subtitleLanguage}</p>
        </div>
      </div>
      <Divider className="gray-border" />
      <div className="px-3 mt-4 mb-4">
        <Button className="xl-btn-primary" label="Đăng ký khoá học" onClick={handleRegister} />
        <div className="flex course-detail-overview-action">
          <Button className="md-btn-outline justify-content-center center-icon-btn" label="Thêm vào giỏ hàng" icon="pi pi-shopping-cart" onClick={handleAddToCart} />
          <Button
            className="md-btn-outline justify-content-center center-icon-btn"
            label={like ? "Đã yêu thích" : "Yêu thích"}
            icon={`pi pi-heart${like ? "-fill" : ""}`}
            onClick={handleLikeClick}
          />
        </div>
        <p className="font-size-14 font-weight-400 line-height-22 gray-color">Lưu ý: tất cả các khóa học đều có đảm bảo hoàn tiền trong 30 ngày</p>
      </div>
      <Divider className="gray-border" />
      <div className="px-3 mt-4 mb-4 course-detail-overview-includes">
        <p className="font-size-16 font-weight-500 line-height-24 default-text">This course includes:</p>
        {courseItemData?.courseIncludes?.includes("LIVETIME") && (
          <div className="flex mb-3">
            <i className="pi pi-clock mr-2 font-size-18 primary-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Truy cập trọn đời</span>
          </div>
        )}
        {courseItemData?.courseIncludes?.includes("REFUND") && (
          <div className="flex mb-3">
            <i className="pi pi-dollar mr-2 font-size-18 primary-color"></i>
            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Đảm bảo hoàn tiền trong 30 ngày</span>
          </div>
        )}
        {courseItemData?.courseIncludes?.includes("DOWNLOAD") && (
          <div className="flex mb-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 10.5H16.5" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10.5 13.5H16.5" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
                stroke="#307DFA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M7.5 3.75V20.25" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Tệp bài tập miễn phí và tài nguyên có thể tải xuống</span>
          </div>
        )}
        {courseItemData?.courseIncludes?.includes("CERTIFICATE") && (
          <div className="flex mb-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.25 5.25V10.4153C5.25 14.1372 8.227 17.2222 11.9488 17.2498C12.8395 17.2566 13.7228 17.087 14.5476 16.7508C15.3725 16.4146 16.1226 15.9185 16.7548 15.291C17.3871 14.6636 17.8889 13.9172 18.2313 13.0949C18.5737 12.2727 18.75 11.3907 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z"
                stroke="#307DFA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M9 21H15" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 17.25V21" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M18.582 12H19.4993C20.295 12 21.058 11.6839 21.6206 11.1213C22.1832 10.5587 22.4993 9.79565 22.4993 9V7.5C22.4993 7.30109 22.4203 7.11032 22.2796 6.96967C22.139 6.82902 21.9482 6.75 21.7493 6.75H18.7493"
                stroke="#307DFA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.43432 12H4.48828C3.69263 12 2.92957 11.6839 2.36696 11.1213C1.80435 10.5587 1.48828 9.79565 1.48828 9V7.5C1.48828 7.30109 1.5673 7.11032 1.70795 6.96967C1.8486 6.82902 2.03937 6.75 2.23828 6.75H5.23828"
                stroke="#307DFA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Giấy chứng nhận hoàn thành có thể chia sẻ</span>
          </div>
        )}
        {courseItemData?.courseIncludes?.includes("ACCESS") && (
          <div className="flex mb-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.5 18L19.5 18C20.3284 18 21 17.3284 21 16.5V6C21 5.17157 20.3284 4.5 19.5 4.5L4.5 4.5C3.67157 4.5 3 5.17157 3 6V16.5C3 17.3284 3.67157 18 4.5 18Z"
                stroke="#307DFA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M15 21H9" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Truy cập trên điện thoại di động, máy tính bảng và TV</span>
          </div>
        )}
        {courseItemData?.courseIncludes?.includes("SUBTITLE") && (
          <div className="flex mb-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12.001H15" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9 15.001H15" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M5.25 3.75098H18.75C18.9489 3.75098 19.1397 3.82999 19.2803 3.97065C19.421 4.1113 19.5 4.30206 19.5 4.50098V18.751C19.5 19.3477 19.2629 19.92 18.841 20.342C18.419 20.7639 17.8467 21.001 17.25 21.001H6.75C6.15326 21.001 5.58097 20.7639 5.15901 20.342C4.73705 19.92 4.5 19.3477 4.5 18.751V4.50098C4.5 4.30206 4.57902 4.1113 4.71967 3.97065C4.86032 3.82999 5.05109 3.75098 5.25 3.75098Z"
                stroke="#307DFA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M7.5 2.25098V5.25098" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 2.25098V5.25098" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16.5 2.25098V5.25098" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Phụ đề tiếng anh</span>
          </div>
        )}
        {courseItemData?.courseIncludes?.includes("ONLINE") && (
          <div className="flex mb-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 16.5L12 21.75L21 16.5" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M3 12L12 17.25L21 12" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M3 7.5L12 12.75L21 7.5L12 2.25L3 7.5Z" stroke="#307DFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <span className="font-size-14 font-weight-400 line-height-20 gray-color">Khóa học trực tuyến 100%</span>
          </div>
        )}
      </div>
      <Divider className="gray-border" />
      <div className="px-3 mt-4">
        <p className="font-size-18 font-weight-500 line-height-28 default-text">Chia sẻ khóa học này:</p>
        <div className="flex gap-2 course-detail-overview-share-wrapper">
          <div className="course-detail-overview-share" onClick={showCopiedToast}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.75 15.749H20.25V3.74902H8.25V8.24902" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15.75 8.24902H3.75V20.249H15.75V8.24902Z" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="font-weight-500 font-size-14 line-height-20 gray-color m-0 ml-1">Sao chép</span>
          </div>
          <div className="course-detail-overview-share-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_7152_27755)">
                <path
                  d="M13.3312 3.32083H15.1571V0.140833C14.8421 0.0975 13.7587 0 12.4971 0C9.86458 0 8.06125 1.65583 8.06125 4.69917V7.5H5.15625V11.055H8.06125V20H11.6229V11.0558H14.4104L14.8529 7.50083H11.6221V5.05167C11.6229 4.02417 11.8996 3.32083 13.3312 3.32083Z"
                  fill="#64748B"
                />
              </g>
              <defs>
                <clipPath id="clip0_7152_27755">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="course-detail-overview-share-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_7152_27758)">
                <path
                  d="M20 3.79875C19.2563 4.125 18.4637 4.34125 17.6375 4.44625C18.4875 3.93875 19.1363 3.14125 19.4412 2.18C18.6488 2.6525 17.7738 2.98625 16.8412 3.1725C16.0887 2.37125 15.0162 1.875 13.8462 1.875C11.5763 1.875 9.74875 3.7175 9.74875 5.97625C9.74875 6.30125 9.77625 6.61375 9.84375 6.91125C6.435 6.745 3.41875 5.11125 1.3925 2.6225C1.03875 3.23625 0.83125 3.93875 0.83125 4.695C0.83125 6.115 1.5625 7.37375 2.6525 8.1025C1.99375 8.09 1.3475 7.89875 0.8 7.5975C0.8 7.61 0.8 7.62625 0.8 7.6425C0.8 9.635 2.22125 11.29 4.085 11.6712C3.75125 11.7625 3.3875 11.8062 3.01 11.8062C2.7475 11.8062 2.4825 11.7913 2.23375 11.7362C2.765 13.36 4.2725 14.5538 6.065 14.5925C4.67 15.6838 2.89875 16.3412 0.98125 16.3412C0.645 16.3412 0.3225 16.3263 0 16.285C1.81625 17.4563 3.96875 18.125 6.29 18.125C13.835 18.125 17.96 11.875 17.96 6.4575C17.96 6.27625 17.9538 6.10125 17.945 5.9275C18.7588 5.35 19.4425 4.62875 20 3.79875Z"
                  fill="#64748B"
                />
              </g>
              <defs>
                <clipPath id="clip0_7152_27758">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="course-detail-overview-share-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 5.25L12 13.5L3 5.25" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
                stroke="#64748B"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M10.3628 12L3.23047 18.538" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M20.7692 18.5381L13.6367 12" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="course-detail-overview-share-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_7152_27769)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.6329 3.34007C14.8788 1.58386 12.5459 0.616264 10.0606 0.615234C4.93934 0.615234 0.7714 4.78306 0.769341 9.90566C0.768654 11.5432 1.19643 13.1417 2.00954 14.5507L0.691406 19.3652L5.61683 18.0732C6.97398 18.8135 8.50188 19.2036 10.0568 19.2041H10.0607C15.1813 19.2041 19.3497 15.0359 19.3517 9.9131C19.3527 7.43042 18.3872 5.09617 16.6329 3.34007ZM10.0606 17.635H10.0574C8.67171 17.6344 7.31273 17.262 6.12689 16.5586L5.84502 16.3911L2.9222 17.1579L3.70235 14.3082L3.51867 14.016C2.74562 12.7865 2.33741 11.3654 2.3381 9.90623C2.3397 5.64846 5.80405 2.18445 10.0637 2.18445C12.1263 2.18513 14.0653 2.98943 15.5233 4.44912C16.9813 5.90881 17.7837 7.84904 17.783 9.91253C17.7812 14.1706 14.3171 17.635 10.0606 17.635ZM14.2965 11.8513C14.0644 11.735 12.923 11.1736 12.7101 11.096C12.4975 11.0185 12.3425 10.9799 12.1879 11.2122C12.0331 11.4445 11.5882 11.9675 11.4527 12.1224C11.3172 12.2773 11.182 12.2968 10.9498 12.1805C10.7176 12.0644 9.96959 11.8191 9.08279 11.0282C8.39271 10.4126 7.92682 9.6524 7.79132 9.42009C7.65605 9.18754 7.79018 9.07402 7.89317 8.9463C8.14448 8.63422 8.39614 8.30704 8.4735 8.1522C8.55098 7.99724 8.51218 7.86163 8.45405 7.74547C8.39614 7.62932 7.93185 6.48662 7.73845 6.02165C7.54985 5.56915 7.35862 5.63026 7.21603 5.62317C7.08076 5.61642 6.92592 5.61504 6.77108 5.61504C6.61635 5.61504 6.36481 5.67306 6.15195 5.90561C5.93921 6.13804 5.33954 6.6996 5.33954 7.84229C5.33954 8.98498 6.17141 10.0889 6.28745 10.2438C6.40349 10.3988 7.92453 12.7437 10.2533 13.7492C10.8072 13.9886 11.2395 14.1313 11.5768 14.2383C12.133 14.415 12.6389 14.39 13.039 14.3303C13.4851 14.2636 14.4124 13.7686 14.606 13.2264C14.7995 12.6841 14.7995 12.2193 14.7413 12.1224C14.6834 12.0256 14.5286 11.9675 14.2965 11.8513Z"
                  fill="#64748B"
                />
              </g>
              <defs>
                <clipPath id="clip0_7152_27769">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
